<template>
    <v-dialog max-width="600" v-model="payDialog" persistent>
        <template #activator="{on}">
            <v-btn outlined color="accent" v-on="on" x-large :disabled="cart.length==0">Pay</v-btn>
        </template>
        <v-card v-if="step=='mail'" :disabled="loading" :loading="loading">
            <v-card-title>User mail ?</v-card-title>
            <v-card-text>
                <v-form ref="emailForm">
                    <v-text-field v-model="email" label="Email" :rules="emailRules" clearable/>
                </v-form>
                <v-row v-if="clients.length">
                    <v-col cols="12">
                        Please choose correct customer
                    </v-col>
                    <v-col v-for="client in clients" :key="client.id" cols="6" @click="chooseClient(client)">
                        <v-card>
                            <v-card-text>
                                #{{client.id}} {{ client.displayName }}<br>{{ client.email }}
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn outlined color="error" @click="cancel()">Cancel</v-btn>
                <v-spacer />
                <v-btn v-if="email && clients.length == 0" @click="step='payment_method'" outlined>Skip and pay</v-btn>
                <v-btn outlined color="accent" @click="saveEmail()">{{email ? 'Search client' : 'Skip and pay'}}</v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="step=='payment_method'" :disabled="loading" :loading="loading">
            <v-card-title>How to pay ?</v-card-title>
            <v-card-text>
                <div class="d-flex justify-space-between mb-4">
                    <div class="subtitle-1">Total Cart</div>
                    <div class="subtitle-1">{{displayPrice(total)}} {{currency}}</div>
                </div>
                <v-item-group v-model="paymentType">
                    <v-row>
                        <v-col cols=6>
                            <v-item v-slot="{ active, toggle }" value="card">
                                <v-card @click="toggle" :color="active?'accent':null">
                                    <v-card-title>Card</v-card-title>
                                </v-card>
                            </v-item>
                        </v-col>
                        <v-col cols=6>
                            <v-item v-slot="{ active, toggle }" value="cash">
                                <v-card @click="toggle" :color="active ?'accent':null">
                                    <v-card-title>Cash</v-card-title>
                                </v-card>
                            </v-item>
                        </v-col>
                        <v-col cols=6>
                            <v-item v-slot="{ active, toggle }" value="credit_hours">
                                <v-card @click="toggle" :color="active ?'accent':null">
                                    <v-card-title>Client Credit Hours</v-card-title>
                                </v-card>
                            </v-item>
                        </v-col>
                    </v-row>
                </v-item-group>
            </v-card-text>
            <v-card-actions>
                <v-btn outlined color="error" @click="cancel">Cancel</v-btn>
                <v-spacer />
                <v-btn outlined color="accent" :disabled="!paymentType" @click="pay">Pay</v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="step=='process'">
            <v-card-title>Process</v-card-title>
            <v-card-text>
                <v-alert v-if="error" type="error">
                    {{ error }}
                </v-alert>
                <v-list>
                    <v-list-item v-for="(proc, idx) in needProcess" :key="proc">
                        <v-list-item-content :class="currentProcess > idx ? 'light-green--text' : 'grey--text'">{{ processes[proc].label}}</v-list-item-content>
                        <v-list-item-avatar>
                            <v-icon :color="currentProcess > idx ? 'success' : 'grey'">{{currentProcess > idx ? 'mdi-checkbox-marked-circle-outline' : 'mdi-radiobox-blank'}}</v-icon>
                        </v-list-item-avatar>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-card-actions></v-card-actions>
        </v-card>
        <v-card v-if="step=='finish'">
            <v-card-title>Order completed</v-card-title>
            <v-card-text></v-card-text>
            <v-card-actions>
                <v-btn outline @click="openOrder">View order</v-btn>
                <v-spacer />
                <v-btn outline color="accent" @click="finish">Finish</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'PosCheckout',
    data: () => ({
        payDialog:false,
        step: 'mail',
        paymentType:null,
        email: null,
        clients: [],
        choosedClient: null,
        emailRules: [
            v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],
        needProcess: [],
        currentProcess: null,
        error: null
    }),
    computed: {
        ...mapGetters('pos', [
            'cart',
            "currency",
            'total',
            'loading',
            'order'
        ]),
        processes () {
            return {
                createCustomer : {
                    label:'Create User',
                    handle: this.createCustomer
                },
                createOrder : {
                    label:'Create order',
                    handle: this.saveOrder
                },
                createInvoice: {
                    label:'Create Invoice',
                    handle: this.createInvoice
                },
                applyPayout: {
                    label: 'Apply payout',
                    handle: this.applyPayout
                }
            }
        }
    },
    methods:{
        ...mapActions('clients', { searchClient:'index' }),
        ...mapActions('pos', ["saveOrder", "checkMail", 'createInvoice', 'applyPayout', 'setPaymentType', 'cleanOrder', 'setClient', 'createCustomer', 'setCustomerMail']),
        chooseClient(client) {
            this.choosedClient=client
            this.setClient(client.id)
            this.step='payment_method'
        },
        displayPrice(price){
            return price.toFixed(2)
        },
        cancel() {
            this.email = null
            this.step = 'mail'
            this.clients = []
            this.payDialog = false
        },
        saveEmail() {
            if(!this.email) {
                this.step='payment_method'
                return
            }
            if(this.$refs.emailForm.validate()) {
                this.searchClient({
                    filter: {
                        email: this.email
                    }
                })
                    .then(({clients}) => {
                        if(clients && clients.data.length > 0){
                            this.clients = clients.data
                        }else{
                            this.setCustomerMail(this.email)
                            this.step='payment_method'
                        }
                    })
            }
        },
        pay(){
            this.error=null
            this.setPaymentType(this.paymentType)
            this.step ='process'
            this.needProcess = [
                'createOrder',
                'createInvoice',
                'applyPayout'
            ]

            if(this.email && !this.choosedClient) {
                this.needProcess.unshift('createCustomer')
            }

            this.currentProcess=0

            this.callProcess()
        },
        callProcess() {
            if(this.currentProcess>=this.needProcess.length){
                this.step = 'finish'
            }
            const processId = this.needProcess[this.currentProcess]
            const proc = this.processes[processId]

            proc.handle()
                .then(() => {
                    this.currentProcess ++
                    this.callProcess()
                })
                .catch((data) => {
                    this.error=data.message
                })
        },
        finish() {
            this.cleanOrder()
            this.step='mail'
            this.payDialog = false
        },
        openOrder() {
            const orderId = this.order.id
            this.finish()
            this.$router.push(`/orders/view/${orderId}`)
        }
    }
}
</script>